(function () {
  'use strict';

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  /* ---------- announcement rotation ---------- */
  function announcements() {
    document.querySelectorAll('[data-announcement]').forEach(function (track) {
      var items = track.querySelectorAll('.announcement__item');
      if (items.length < 2) return;
      var i = 0;
      var speed = (parseInt(track.dataset.speed, 10) || 5) * 1000;
      setInterval(function () {
        items[i].classList.remove('is-active');
        i = (i + 1) % items.length;
        items[i].classList.add('is-active');
      }, speed);
    });
  }

  /* ---------- mobile drawer ---------- */
  function drawer() {
    var dr = document.querySelector('[data-drawer]');
    if (!dr) return;
    function set(open) {
      dr.classList.toggle('is-open', open);
      dr.setAttribute('aria-hidden', open ? 'false' : 'true');
      document.body.style.overflow = open ? 'hidden' : '';
      var trigger = document.querySelector('[data-drawer-open]');
      if (trigger) trigger.setAttribute('aria-expanded', open ? 'true' : 'false');
    }
    document.querySelectorAll('[data-drawer-open]').forEach(function (b) { b.addEventListener('click', function () { set(true); }); });
    document.querySelectorAll('[data-drawer-close]').forEach(function (b) { b.addEventListener('click', function () { set(false); }); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') set(false); });
  }

  /* ---------- hero slideshow ---------- */
  function slideshow() {
    document.querySelectorAll('[data-slideshow]').forEach(function (root) {
      var track = root.querySelector('[data-slide-track]');
      if (!track) return;
      var slides = track.querySelectorAll('.hero__slide');
      var caps = root.querySelectorAll('.hero__cap');
      var dots = root.querySelectorAll('[data-dot]');
      if (!slides.length) return;

      function step() { return slides[0].getBoundingClientRect().width; }
      function index() { return Math.round(track.scrollLeft / step()); }
      function sync() {
        var i = Math.min(index(), slides.length - 1);
        caps.forEach(function (c, k) { c.classList.toggle('is-active', k === i); });
        dots.forEach(function (d, k) { d.classList.toggle('is-active', k === i); });
      }
      function go(i) { track.scrollTo({ left: step() * i, behavior: 'smooth' }); }

      var prev = root.querySelector('[data-slide-prev]');
      var next = root.querySelector('[data-slide-next]');
      if (prev) prev.addEventListener('click', function () { go(Math.max(index() - 1, 0)); });
      if (next) next.addEventListener('click', function () { go(Math.min(index() + 1, slides.length - 1)); });
      dots.forEach(function (d) { d.addEventListener('click', function () { go(parseInt(d.dataset.dot, 10)); }); });

      var t;
      track.addEventListener('scroll', function () { clearTimeout(t); t = setTimeout(sync, 80); });

      if (root.dataset.autoplay === 'true' && slides.length > 1) {
        var ms = (parseInt(root.dataset.interval, 10) || 6) * 1000;
        var timer = setInterval(function () {
          var i = index();
          go(i >= slides.length - 1 ? 0 : i + 1);
        }, ms);
        root.addEventListener('mouseenter', function () { clearInterval(timer); });
      }
      sync();
    });
  }

  /* ---------- horizontal product rows ---------- */
  function rows() {
    document.querySelectorAll('[data-row]').forEach(function (row) {
      var section = row.closest('.shopify-section') || document;
      var prev = section.querySelector('[data-row-prev]');
      var next = section.querySelector('[data-row-next]');
      function step() { return Math.round(row.clientWidth * 0.8); }
      if (prev) prev.addEventListener('click', function () { row.scrollBy({ left: -step(), behavior: 'smooth' }); });
      if (next) next.addEventListener('click', function () { row.scrollBy({ left: step(), behavior: 'smooth' }); });
    });
  }

  /* ---------- count-up stats ---------- */
  function countUp() {
    var nodes = document.querySelectorAll('[data-countup]');
    if (!nodes.length) return;
    function run(el) {
      var target = parseInt(el.dataset.countup, 10);
      if (isNaN(target)) { el.textContent = el.dataset.countup; return; }
      var v = 0, steps = 50, inc = Math.ceil(target / steps);
      var iv = setInterval(function () {
        v += inc;
        if (v >= target) { v = target; clearInterval(iv); }
        el.textContent = v.toLocaleString(document.documentElement.lang || 'fr');
      }, 26);
    }
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (en.isIntersecting) { run(en.target); io.unobserve(en.target); }
        });
      }, { threshold: 0.4 });
      nodes.forEach(function (n) { io.observe(n); });
    } else {
      nodes.forEach(run);
    }
  }

  /* ---------- product gallery + variants + qty ---------- */
  function product() {
    var main = document.getElementById('MainImage');
    document.querySelectorAll('[data-thumb]').forEach(function (t) {
      t.addEventListener('click', function () {
        if (!main) return;
        main.src = t.dataset.src;
        main.removeAttribute('srcset');
        document.querySelectorAll('[data-thumb]').forEach(function (x) { x.classList.remove('is-active'); });
        t.classList.add('is-active');
      });
    });

    document.querySelectorAll('[data-qty]').forEach(function (b) {
      b.addEventListener('click', function () {
        var input = b.parentElement.querySelector('input');
        var v = parseInt(input.value, 10) || 1;
        input.value = Math.max(1, v + parseInt(b.dataset.qty, 10));
      });
    });

    var variantSelect = document.querySelector('[data-variant-select]');
    var optionSelects = document.querySelectorAll('[data-option-index]');
    if (!variantSelect || !optionSelects.length) return;

    function update() {
      var chosen = [];
      optionSelects.forEach(function (s) { chosen[parseInt(s.dataset.optionIndex, 10)] = s.value; });
      var want = chosen.join('|');
      var match = null;
      Array.prototype.forEach.call(variantSelect.options, function (o) {
        if (o.dataset.options === want) match = o;
      });
      if (!match) return;
      variantSelect.value = match.value;
      var priceEl = document.querySelector('[data-price]');
      if (priceEl && match.dataset.price) priceEl.textContent = match.dataset.price;
      var addBtn = document.querySelector('[data-add]');
      if (addBtn) addBtn.disabled = match.disabled;
    }
    optionSelects.forEach(function (s) { s.addEventListener('change', update); });
  }

  /* ---------- back to top ---------- */
  function toTop() {
    var btn = document.getElementById('ToTop');
    if (!btn) return;
    window.addEventListener('scroll', function () {
      btn.classList.toggle('is-on', window.scrollY > 700);
    }, { passive: true });
    btn.addEventListener('click', function () { window.scrollTo({ top: 0, behavior: 'smooth' }); });
  }

  ready(function () {
    announcements(); drawer(); slideshow(); rows(); countUp(); product(); toTop();
  });

  /* theme editor re-init */
  document.addEventListener('shopify:section:load', function () {
    announcements(); drawer(); slideshow(); rows(); countUp(); product();
  });
})();
